module.exports = __webpack_public_path__ + "img/thumb-oamm2a.291a38ad.png";